import React from 'react';
export const ITEMS_ORDER = ['services', 'equipments', 'bathroomEquipments'];

export const SECTION_LABELS = {
  equipments: 'common.accommodations.equipments',
  services: 'common.accommodations.services',
  bathroomEquipments: 'common.accommodations.bathroomEquipments',
};

export type ComparatorColumn = {
  title: string;
  price?: React.ReactNode;
  picture: { url: string };
  isExclusiveCollection: boolean;
  isExclusiveCollectionSpace: boolean;
  surface: string;
  capacity: string;
  strengths: Array<{ id: string; label: string }>;
};

export type ComparatorAvailabilityBoard = Record<string, Array<boolean>>;

export type ComparatorAllAvailableItems = Array<Array<{ id: string; label: string }>>;

export const sortCategoriesItems = ({ ranking: rankingA }, { ranking: rankingB }) => {
  if (rankingB < rankingA) {
    return 1;
  }
  if (rankingB > rankingA) {
    return -1;
  }
};
